var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcShieldReportRegular = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.8 4.6c-.7-.8-6.7-2.8-7.8-2.8s-7.1 2-7.9 2.8c-.6.7-.6 1.2-.6 3.8v4.3c0 6.9 7.9 9.3 8.2 9.4h.4c.3-.1 8.2-2.6 8.2-9.4V8.4c.2-2.6.2-3.1-.5-3.8m-.9 3.7v4.3c0 5.2-5.7 7.5-6.9 7.9-1.2-.4-6.9-2.7-6.9-7.9V8.2c0-2.1 0-2.4.1-2.6.6-.5 6-2.4 6.8-2.4s6.2 1.9 6.8 2.4c.2.3.2.6.1 2.7"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 13.2c.4 0 .8-.3.8-.8V8c0-.4-.3-.8-.8-.8s-.8.4-.8.8v4.4c0 .4.4.8.8.8M12 14.6c-.6 0-1 .4-1 1s.5 1 1 1 1-.4 1-1-.4-1-1-1"
})));
export default SvgIcShieldReportRegular;